import { createStore } from 'vuex'

export default createStore({
	state: {
		token: '',
		isAuthenticated: false,
		comp_cd: '',
		sidebar_datetime: '',
	},
	getters: {
		token(state) {
			return state.token
		},
		isAuthenticated(state) {
			return state.isAuthenticated
		},
		comp_cd(state) {
			return state.comp_cd
		},
		sidebar_datetime(state) {
			return state.sidebar_datetime
		}
	},
	mutations: {
		initializeStore(state) {
			if (localStorage.getItem('three_token')) {
				state.token = localStorage.getItem('three_token')
				state.isAuthenticated = true
				if (localStorage.getItem('three_comp_cd')) {
					state.comp_cd = localStorage.getItem('three_comp_cd')
				}
			} else {
				state.token = ''
				state.isAuthenticated = false
				state.comp_cd = ''
			}
		},
		setToken(state, param) {
			state.token = param.token
			state.isAuthenticated = true
			if (param.remember_device) {
				localStorage.setItem('three_token', param.token)
			}
		},
		removeToken(state) {
			state.token = ''
			state.isAuthenticated = false
			localStorage.removeItem('three_token')
		},
		set_comp_cd(state, comp_cd) {
			state.comp_cd = comp_cd
			localStorage.setItem('three_comp_cd', comp_cd)
		},
		remove_comp_cd(state) {
			state.comp_cd = ''
			localStorage.removeItem('three_comp_cd')
		},
		set_sidebar_datetime(state, sidebar_datetime) {
			state.sidebar_datetime = sidebar_datetime
		},
	},
	actions: {
	},
	modules: {
	}
})
